import type { DeutscheBahnPassenger } from "../types";

/**
 * Strips the UI-only `hasRemove` flag, leaving the fields the API consumes
 * (first_name, last_name, passenger_type). Children and infants are sent too — they travel free.
 */
export function mapDeutscheBahnPassengersForApi(passengerList: DeutscheBahnPassenger[]) {
  return (Array.isArray(passengerList) ? passengerList : []).map(
    ({ hasRemove: _hasRemove, ...passenger }) => passenger
  );
}
